import { filterUndefinedAndEmptyValues, gtmEvent } from '../../../utils/gtmEvents';
import { useAppSelector } from '../../utils';
import { selectBodyTypesForGtm, selectCurrentVehicleFromVehicles } from '../../reducers/vehicles';
import { selectCurrentVehicle } from '../../reducers/currentVehicle';
import { removeAllTagsFromMarkdown } from '../../../utils/markdown';
const useBapCtaClickGtm = () => {
    const gtmBodyStyle = useAppSelector(selectBodyTypesForGtm);
    const { inventoryStatus } = useAppSelector(selectCurrentVehicle);
    const currentVehicle = useAppSelector(selectCurrentVehicleFromVehicles);
    const fireGtmEvent = ({ event = 'cta_click', ctaType, ctaPlacement, componentType, linkText, linkUrl }) => {
        const { modelKey, modelGtmName, modelName, trimKey, trimName, trimGtmName } = currentVehicle;
        const model = modelGtmName || modelName || modelKey;
        const trim = trimGtmName || trimName || trimKey;
        const gtmPayload = {
            event,
            cta_type: ctaType,
            cta_placement: ctaPlacement,
            component_type: componentType,
            model: removeAllTagsFromMarkdown(model),
            trim: removeAllTagsFromMarkdown(trim),
            availability_flag: inventoryStatus,
            body_style: gtmBodyStyle,
        };
        if (linkText)
            gtmPayload.link_text = linkText;
        if (linkUrl)
            gtmPayload.link_url = linkUrl;
        const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
        gtmEvent(filteredPayload);
    };
    return { fireGtmEvent, currentVehicle };
};
export default useBapCtaClickGtm;
